export default {"src":"/_next/static/media/rating-star-empty.62e10cea.svg","height":11,"width":11,"blurWidth":0,"blurHeight":0};